import { useContext, useState } from "react";
import { DataContext } from "../../utils/contexts";
import { exportPdf } from "utils";
import { ExportExcelBuildItem, ExportPdfBuildItem } from "../../ItemReceived/components";
import { useListExportNew } from "pages/Inventori/Transaction/AddNewItem/utils";
import { BuildFile } from "../RegisterItemsBuild";
import ModalConfirmExport from "../../components/ModalConfirmExport";

export function ModalExportBuild(props: {
    type: "excel" | "pdf" | string,
    setIsOpen: React.Dispatch<React.SetStateAction<{ isOpen: boolean; type: string, activeTab: string | null }>>
}) {
    const [amount, setAmount] = useState<number>(10)
    const { fill, activeColumn } = useContext(DataContext)

    const { data } = useListExportNew("build", {
        start_date: fill.dateFrom,
        end_date: fill.dateTo,
        approve_status: fill.approval_status,
        location_id: fill.location_id,
        group_id: fill.group_id,
        jumlah_item: amount
    })

    return (

        <ModalConfirmExport
            isOpen={true}
            setIsOpen={props.setIsOpen}
            amount={amount}
            setAmount={setAmount}
            title="Item Build Item"
            type={props.type as "excel" | "pdf"}
            total={data.total_record}
            onExport={() => {
                if (props.type === "excel") {
                    ExportExcelBuildItem({
                        data: data.items as BuildFile[],
                        filter: {
                            dateFrom: fill.dateFrom,
                            dateTo: fill.dateTo
                        },
                        module: "INVENTORY",
                        title: "REGISTER BUILD ITEM",
                        fileName: "register_build_item",
                        activeColumns: activeColumn!
                    });
                }

                if (props.type === "pdf") {
                    const documentComponent = (
                        <ExportPdfBuildItem data={data.items as BuildFile[]} filter={fill} tableActive={activeColumn!} />
                    )
                    exportPdf({ documentComponent, fileName: "register_build_item" })
                }
            }}
        />
    )
}